import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import common from './common.module.scss';
import icon from './icon.module.scss';
import cancel from './cancel.module.scss';
import link from './link.module.scss';
import logout from './logout.module.scss';
import success from './success.module.scss';
import error from './error.module.scss';
import primary from './primary.module.scss';
import navy from './navy.module.scss';
import warning from './warning.module.scss';
import secondary from './secondary.module.scss';
import upload from './upload.module.scss';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {useGlobalContext} from "../../contexts/GlobalContext";
import themeStyles from '../../styles/theme.module.scss';

const ButtonAction = ({
                        variant = 'primary',
                        iconButtonType = 'primary',
                        label,
                        customClassnames = '',
                        useIcon = '',
                        onClick,
                        disabled = false,
                        avoidDoubleClick = true,
                        ...rest
                      }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleClick = async () => {
    if (isSubmitting) return;
    if (avoidDoubleClick) {
      if (onClick) {
        setIsSubmitting(true);
        try {
          await onClick();
        } finally {
          setTimeout(() => setIsSubmitting(false), 1500);
        }
      }
    } else {
      await onClick();
    }
  };

  const {isGlassTheme} = useGlobalContext();

  switch (variant) {
    case 'icon':
      return (
        <button
          className={classNames(
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            common.button,
            icon.iconButton,
            {[icon.warning]: iconButtonType === 'warning'},
            {[icon.cancel]: iconButtonType === 'cancel'},
            {[icon.error]: iconButtonType === 'error'},
            {[icon.success]: iconButtonType === 'success'},
            {[icon.primary]: iconButtonType === 'primary'},
            {[icon.secondary]: iconButtonType === 'secondary'},
            {[icon.navy]: iconButtonType === 'navy'},
            customClassnames
          )}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          {label}
        </button>
      );
    case 'link':
      return (
        <button
          className={classNames(
            link.linkButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames
          )}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          {label}
        </button>
      );
    case 'upload':
      return (
        <button
          className={classNames(
            common.button,
            upload.uploadButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames
          )}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'cancel':
      return (
        <button
          className={classNames(
            common.button,
            cancel.cancelButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames
          )}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'logout':
      return (
        <Link
          to="/logout"
          className={classNames(
            common.button,
            logout.logoutButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            <FormattedMessage id="userInfo-btn-logout" defaultMessage="Logout"/>
          </div>
        </Link>
      );
    case 'success':
      return (
        <button
          className={classNames(
            common.button,
            success.successButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'warning':
      return (
        <button
          className={classNames(
            common.button,
            warning.warningButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'navy':
      return (
        <button
          className={classNames(
            common.button,
            navy.navyButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'secondary':
      return (
        <button
          className={classNames(common.button, secondary.secondaryButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'error':
      return (
        <button
          className={classNames(common.button, error.errorButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
    case 'primary':
    default:
      return (
        <button
          className={classNames(common.button, primary.primaryButton,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.jump : themeStyles.noJump,
            customClassnames)}
          onClick={handleClick}
          disabled={disabled || isSubmitting}
          {...rest}
        >
          <div className={common.labelContainer}>
            {useIcon && <img src={toAbsoluteUrl(useIcon)} alt="icon"/>}
            {label}
          </div>
        </button>
      );
  }
};

export default ButtonAction;